import React, { useState } from "react";
import style from "../stylees/add.module.css";
import { ref, update } from "firebase/database";
import database from "../firebase";
import { FaRegEdit } from "react-icons/fa";
export default function Edit({ patient, onSave }) {
  // Local state to store the edited patient data
  const [editedPatient, setEditedPatient] = useState({
    history: patient.history,
    note: patient.note,
    ward: patient.ward,
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedPatient((prev) => ({ ...prev, [name]: value }));
  };
  // Handle save
  const handleSave = () => {
    console.log(patient);
    // Call the onSave function passed from the parent to update the patien
      const patientRef = ref(database, `patients/${patient.id}`);
      update(patientRef, editedPatient)
        .then(() => {
          console.log(`Patient  updated `);
        })
        .catch((error) => {
          console.error("Error updating patient:", error);
        });
    

  };

  return (
    <div>
      <button
        type="button"
        className="btn btn-outline-primary btn-sm"
        data-bs-toggle="modal"
        data-bs-target={`#editModal-${patient.id}`} // Unique ID for each modal
      >
       <FaRegEdit className="fs-4"/>
      </button>

      {/* Modal */}
      <div
        className="modal fade"
        id={`editModal-${patient.id}`}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-dark" id="exampleModalLabel">
                Edit Patient (<span className="text-muted fw-bold">{patient.name}</span>)
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                {/* History */}
                <div className="col-12">
                  <label htmlFor="history" className="form-label">
                    History
                  </label>
                  <input
                    type="text"
                    className={`form-control ${style.inputChange}`}
                    name="history"
                    id="history"
                    placeholder="Enter the history"
                    value={editedPatient.history}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Note */}
                <div className="col-12">
                  <label htmlFor="note" className="form-label">
                    Note
                  </label>
                  <input
                    type="text"
                    className={`form-control ${style.inputChange}`}
                    name="note"
                    id="note"
                    placeholder="Enter the patient note"
                    value={editedPatient.note}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Ward */}
                <div className="col-12">
                  <label htmlFor="ward" className="form-label">
                    Ward
                  </label>
                  <input
                    type="text"
                    className={`form-control ${style.inputChange}`}
                    name="ward"
                    id="ward"
                    placeholder="Enter the patient ward"
                    value={editedPatient.ward}
                    onChange={handleInputChange}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal" // Close the modal on save
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
